import * as React from 'react';
import PromoCard from '../../components/PromoCard';

export default () => (
  <PromoCard
    image_url="/images/feedback.png"
    title="Businesses featured on Filtru app"
    subtitle="Filtru actively curates coffee businesses
      on the 'Discover' tab, reaching over 3,000 active users a month.
      We are currently seeking partnerships and content creators.
      Get in touch: hello@filtru.coffee"
  />
);
